import axios from "axios";
import fileDownload from "js-file-download";

import { API_URLS } from "src/utils/API_URLS";

export interface AudienceOverlapSocialProfile {
  socialProvider: string;
  socialUsername: string;
}

export interface CreatorsAudienceOverlapRequest {
  socialProfiles: AudienceOverlapSocialProfile[];
  workspaceUuid: string;
  // the project the creators come from, it decides who is allowed to run the analysis
  wsProjectUuid?: string;
  force?: boolean;
}

const post = (url: string, request: CreatorsAudienceOverlapRequest) =>
  axios.post(
    url,
    {
      socialProfiles: request.socialProfiles,
      wsProjectUuid: request.wsProjectUuid,
      force: request.force ?? false,
    },
    { headers: { "Workspace-Uuid": request.workspaceUuid } },
  );

export const calculateCreatorsAudienceOverlap = async (
  request: CreatorsAudienceOverlapRequest,
) =>
  (await post(API_URLS.calculateCreatorsAudienceOverlap, request)).data.content;

export const getCreatorsAudienceOverlapState = async (
  request: CreatorsAudienceOverlapRequest,
) =>
  (await post(API_URLS.getCreatorsAudienceOverlapState, request)).data.content;

export const downloadCreatorsAudienceOverlapXlsx = async (
  request: CreatorsAudienceOverlapRequest,
) => {
  const response = await axios.post(
    API_URLS.downloadCreatorsAudienceOverlapXlsx,
    {
      socialProfiles: request.socialProfiles,
      wsProjectUuid: request.wsProjectUuid,
    },
    {
      headers: { "Workspace-Uuid": request.workspaceUuid },
      responseType: "blob",
    },
  );
  const fileName = response.headers["content-disposition"]
    ?.split("filename=")[1]
    ?.replace(/"/g, "");

  fileDownload(response.data, fileName || "audience-overlap.xlsx");
};
